import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Database } from './abstract';

export function useDb<D extends Database, R>(db$: Observable<D>, cb: (db: D) => Observable<R>) {
	return db$.pipe(mergeMap(db => cb(db)));
}
